export default {
  title: 'ShipsLand',
  company: 'FS Service Inc.',
  address: '126 Pennsylvania Avenue Unit 5 Paterson, New Jersey, USA.',
  address1: 'İkitelli OSB Mah., Bedrettin Dalan Bulvarı, Metro İş Merkezi B-2 No:35, Başakşehir, Istanbul, Turkey.',
  address2: 'TianHe District, No.167, Linhe Xi Road, Building No: 2605, Guangzhou, Guangdong, China.',
};
